var CommunityRegionPage;
(function (CommunityRegionPage) {
    function loadListings(regionId, showDetails) {
        var addrTitle;
        if (showDetails) {
            addrTitle = "Address";
        }
        else {
            addrTitle = "Suburb";
        }
        var fullCount = -1;
        $('#listings').DataTable({
            scrollX: true,
            lengthChange: false,
            ordering: false,
            info: true,
            searching: true,
            paging: true,
            pageLength: 20,
            pagingType: "full_numbers",
            processing: true,
            serverSide: true,
            searchDelay: 1500,
            stateSave: false,
            language: {
                emptyTable: "No locations",
                zeroRecords: "No matching locations"
            },
            //oLanguage: {
            //    sSearch: "Search by Location, Service, or Category:"
            //},
            columns: [
                { title: "Location" },
                { title: addrTitle, className: "" },
                { title: "Contact", className: "centered" },
                { title: "Service - Category", className: "services" },
                //{ title: "Description" },
            ],
            ajax: function (data, callback, settings) {
                var s = data.search.value || "-";
                var p = (data.start / 20) + 1;
                var url = "/api/search/regional/".concat(regionId, "/").concat(s, "/").concat(p, "/").concat(data.draw);
                var hasServiceChanges = $('#service-changes-filter').is(':checked') == true ? 1 : 0;
                if (parseInt($('#ListingsWithinCouncilID').val()) > 0) {
                    url = "/api/search/regioncouncil/".concat($('#ListingsWithinCouncilID').val(), "/").concat(s, "/").concat(p, "/").concat(data.draw, "/").concat(hasServiceChanges);
                }
                $.getJSON(url, function (d) {
                    if (fullCount === -1) {
                        fullCount = d.Total;
                    }
                    var a = { data: [], recordsTotal: fullCount, recordsFiltered: d.Total };
                    // Object to track existing outlet entries by a composite key of OutletID and Phone
                    var outletLookup = {};
                    d.Results.forEach(function (item) {
                        var phone, addr;
                        phone = item.Outlet.Phone || "";
                        var pstripped = phone.replace(/[^0-9]+/g, "");
                        phone = pstripped.length === 0 ? "" : "<a href='tel:".concat(pstripped, "'><span>").concat(phone, "</span></a>");
                        addr = "<span>".concat(item.Outlet.DisplayAddress, "</span>");
                        if (!showDetails) {
                            phone = "<a href='".concat(item.Url, "' class='btn btn-small btn-blue'><span>Contact Us</span></a>");
                            addr = item.Outlet.Suburb;
                        }
                        var services = "<ul>"; // Start the unordered list
                        item.SubResults.forEach(function (service) {
                            var categoryName = service.Category.Name;
                            if (!categoryName || categoryName.length < 1)
                                categoryName = item.Category.Name;
                            var serviceName = item.Service.DisplayName;
                            if (!serviceName || serviceName.length < 1)
                                serviceName = categoryName;
                            var openHours = '';
                            if (item.OpenHours && item.OpenHours !== null) {
                                openHours = "(".concat(item.OpenHours, ") ");
                            }
                            var popup = '';
                            if (item.ServiceChanges && item.ServiceChanges.length > 0) {
                                var serviceChangeList = '<ul>';
                                item.ServiceChanges.forEach(function (change) {
                                    serviceChangeList += "<li>".concat(change, "</li>");
                                });
                                serviceChangeList += '</ul>';
                                var locationUrl = "/Outlet/".concat(item.Outlet.OutletID, "/").concat(item.Outlet.Nickname.replace(/[^a-zA-Z0-9]+/g, '_'));
                                var locationAddr = addr;
                                if (showDetails) {
                                    locationAddr = item.Outlet.DisplayAddress;
                                }
                                popup = "\n                                    <span class=\"service-change-popup\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This service has new changes. Click this icon to View\" data-service-link=\"".concat(service.Url, "\" data-outlet-url=\"").concat(locationUrl, "\" data-service-id=\"").concat(item.OutletServiceID, "\" data-service-name=\"").concat(serviceName, "\" data-service-category=\"").concat(categoryName, "\" data-location-name=\"").concat(item.Outlet.Nickname, "\" data-location-address=\"").concat(locationAddr, "\">\n                                        <i class=\"fa-solid fa-triangle-exclamation\" style=\"color: #C65010;\"></i>\n                                        <div class=\"popup-content\" style=\"display:none;\">\n                                            ").concat(serviceChangeList, "\n                                        </div>\n                                    </span>\n                                    &nbsp;\n                                ");
                            }
                            services += "<li>".concat(popup).concat(openHours, "<a href='").concat(service.Url, "'><span>").concat(serviceName, "</span></a><span> - ").concat(categoryName, "</span></li>");
                        });
                        services += "</ul>"; // Close the unordered list
                        var outletID = item.Outlet.OutletID;
                        var compositeKey = "".concat(outletID); // Create a composite key
                        // Check if the outlet already exists in the lookup
                        if (outletLookup[compositeKey]) {
                            // If it exists, just append the new service to the existing services
                            outletLookup[compositeKey].services += services;
                        }
                        else {
                            var locationUrl = "/Outlet/".concat(item.Outlet.OutletID, "/").concat(item.Outlet.Nickname.replace(/[^a-zA-Z0-9]+/g, '_'));
                            // If it doesn't exist, create a new entry
                            var entry = {
                                nickname: "<a href='".concat(locationUrl, "'><span>").concat(item.Outlet.Nickname, "</span></a>"),
                                address: addr,
                                phone: phone,
                                services: services,
                                outletID: outletID
                            };
                            outletLookup[compositeKey] = entry;
                            a.data.push(entry);
                        }
                    });
                    // Transform data for final output, if necessary
                    a.data = a.data.map(function (entry) {
                        return [
                            "<div>".concat(entry.nickname, "</div>"),
                            "<div>".concat(entry.address, "</div>"),
                            "<div>".concat(entry.phone, "</div>"),
                            "<div>".concat(entry.services, "</div>"),
                            "<div>".concat(entry.outletID, "</div>")
                        ];
                    });
                    callback(a);
                    function scrollToTable() {
                        $('html, body').animate({
                            scrollTop: $('#listings-table').offset().top - 10
                        }, 400);
                    }
                    scrollToTable();
                    // this rebinds event listener everytime a request is completed to
                    // prevent double scrollTop to the table
                    $('#service-changes-filter').off('change').on('change', function () {
                        // reload on filter change
                        $('#listings').dataTable().api().ajax.reload();
                        // and scroll
                        scrollToTable();
                    });
                    $('#listings').off('click touchend').on('click touchend', '.service-change-popup', function () {
                        var serviceChangeContent = $(this).find('.popup-content');
                        if (serviceChangeContent && serviceChangeContent.length > 0) {
                            $('#service-change-modal').find('.service-change-content-wrapper').empty();
                            $('#service-change-modal').find('.service-change-content-wrapper').append(serviceChangeContent.html());
                            $('#service-change-modal').find('.service-change-content-wrapper').find('.popup-content').show();
                        }
                        $('#service-change-modal').find('.service-change-location-name').text($(this).data('location-name'));
                        $('#service-change-modal').find('.service-change-category').text($(this).data('service-category'));
                        $('#service-change-modal').find('.service-change-service-name').text($(this).data('service-name'));
                        $('#service-change-modal').find('.service-change-location-address').text($(this).data('location-address'));
                        $('#service-change-modal').find('.service-change-service-link').attr('href', $(this).data('service-link'));
                        $('#service-change-modal').find('.service-change-outlet-url').attr('href', $(this).data('outlet-url'));
                        $('#service-change-modal').modal('show');
                    });
                });
            }
        }).on('processing.dt', function (e, settings, processing) {
            if (processing) {
                Page.ShowThinking("#listings_processing");
            }
        });
        $("#listings-table input[type=search]").attr("aria-label", "Type to filter listings with matching search terms");
    }
    function Init(communityRegionID, userHasAccessToDetails, showListings, mapModel) {
        $(function () {
            Common.InitEmail(function (d) {
                return {
                    OutletID: d.data("outlet"),
                    OutletServiceID: d.data("service"),
                    CategoryID: d.data("category"),
                    CouncilRegionID: d.data("region"),
                    FromName: $("#txt-name").val(),
                    FromEmail: $("#txt-email").val(),
                    Phone: $("#txt-phone").val(),
                    Message: $("#txt-enquiry").val()
                };
            });
            Common.LoadPromotions();
            if (showListings) {
                loadListings(communityRegionID, userHasAccessToDetails);
            }
            if (mapModel.Loaded) {
                var map;
                var boundaryLayer;
                function showMap() {
                    var mapOptions = {
                        center: new google.maps.LatLng(mapModel.CentralLatitude, mapModel.CentralLongitude),
                        zoom: 12,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    };
                    map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
                    boundaryLayer = new google.maps.KmlLayer({ url: mapModel.KmlLocation + "?x=0" });
                    boundaryLayer.setMap(map);
                }
                google.maps.event.addDomListener(window, 'load', showMap);
            }
        });
    }
    CommunityRegionPage.Init = Init;
})(CommunityRegionPage || (CommunityRegionPage = {}));
